module.exports = __webpack_public_path__ + "media/icons/login@3x-1edd3189.svg";